import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import "./Pricing.css";
import solarPanelImg from "../assets/download.jpg";
import onGridImg from "../assets/download (1).jpg";
import rooftopImg from "../assets/download (2).jpg";
import groundMountedImg from "../assets/download (3).jpg";
import offGridImg from "../assets/battery.jpg";
import streetLightImg from "../assets/pexels-photo-4254167.jpeg";
import waterHeaterImg from "../assets/storage.jpg";
import cleaningImg from "../assets/pexels-photo-9875441.jpeg";

function Pricing() {
  const plans = [
    { name: "Starter", price: 49 },
    { name: "Professional", price: 99, featured: true },
    { name: "Enterprise", price: 199 },
  ];

  return (
    <>
  
     <section className="services-page">
      <h1 className="services-title">Our Solar Services</h1>

      {/* Solar Panel Installation */}
      <div className="solution-row">
        <div className="solution-content">
          <h2>☀️ Solar Panel Installation</h2>
          <p>
            We offer high-efficiency solar panel installations using top-quality
            modules to ensure maximum power generation and durability.
          </p>

          <h4>Services Include:</h4>
          <ul>
            <li>Residential & commercial solar panel installation</li>
            <li>High-performance mono & poly crystalline panels</li>
            <li>Customized system design based on energy needs</li>
          </ul>

          <h4>Benefits:</h4>
          <ul>
            <li>Reduced electricity bills</li>
            <li>Clean and renewable energy</li>
            <li>Long lifespan with minimal maintenance</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={solarPanelImg} alt="Solar Panel Installation" className="solution-image" />
        </div>
      </div>

      {/* On-Grid Solar Systems */}
      <div className="solution-row reverse">
        <div className="solution-content">
          <h2>🔌 On-Grid Solar Systems</h2>
          <p>
            Our on-grid solar solutions allow you to generate electricity and export
            surplus power back to the grid through net metering.
          </p>

          <h4>Features:</h4>
          <ul>
            <li>Grid-connected rooftop systems</li>
            <li>Net metering support & documentation</li>
            <li>Smart inverters for efficient energy usage</li>
          </ul>

          <p className="ideal-for">
            <strong>Ideal For:</strong> Homes, offices, schools, shops, and
            commercial buildings.
          </p>
        </div>
        <div className="solution-image-container">
          <img src={onGridImg} alt="On-Grid Solar Systems" className="solution-image" />
        </div>
      </div>

      {/* Rooftop Solar */}
      <div className="solution-row">
        <div className="solution-content">
          <h2>🏠 Rooftop Solar Solutions</h2>
          <p>
            Make the most of your unused rooftop space with our customized rooftop
            solar systems.
          </p>

          <h4>What We Provide:</h4>
          <ul>
            <li>Structural assessment & design</li>
            <li>Residential and commercial rooftops</li>
            <li>Safe and secure mounting systems</li>
          </ul>

          <h4>Advantages:</h4>
          <ul>
            <li>Saves up to 70% on electricity bills</li>
            <li>Increases property value</li>
            <li>Eco-friendly power generation</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={rooftopImg} alt="Rooftop Solar Solutions" className="solution-image" />
        </div>
      </div>

      {/* Ground Mounted */}
      <div className="solution-row reverse">
        <div className="solution-content">
          <h2>🌱 Ground Mounted Solar Systems</h2>
          <p>
            Perfect for large open spaces and high-capacity power generation.
          </p>

          <h4>Applications:</h4>
          <ul>
            <li>Industrial plants</li>
            <li>Farms & open land</li>
            <li>Institutions & solar parks</li>
          </ul>

          <h4>Highlights:</h4>
          <ul>
            <li>Easy maintenance access</li>
            <li>High energy output</li>
            <li>Long-term performance stability</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={groundMountedImg} alt="Ground Mounted Solar Systems" className="solution-image" />
        </div>
      </div>

      {/* Off-Grid */}
      <div className="solution-row">
        <div className="solution-content">
          <h2>🔋 Off-Grid Solar Systems</h2>
          <p>
            Our off-grid solutions ensure uninterrupted power supply in remote or
            power-cut areas.
          </p>

          <h4>Includes:</h4>
          <ul>
            <li>Solar panels + batteries + inverter</li>
            <li>Reliable backup during outages</li>
            <li>Ideal for rural & remote locations</li>
          </ul>

          <h4>Benefits:</h4>
          <ul>
            <li>Complete energy independence</li>
            <li>No dependency on electricity grid</li>
            <li>Continuous power availability</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={offGridImg} alt="Off-Grid Solar Systems" className="solution-image" />
        </div>
      </div>

      {/* Street Light */}
      <div className="solution-row reverse">
        <div className="solution-content">
          <h2>🚦 Solar Street Light Systems</h2>
          <p>
            We design and install solar street lighting systems for public and
            private spaces.
          </p>

          <h4>Suitable For:</h4>
          <ul>
            <li>Roads & highways</li>
            <li>Societies & campuses</li>
            <li>Industrial areas</li>
          </ul>

          <h4>Key Benefits:</h4>
          <ul>
            <li>Zero electricity cost</li>
            <li>Automatic dusk-to-dawn operation</li>
            <li>Low maintenance & long life</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={streetLightImg} alt="Solar Street Light Systems" className="solution-image" />
        </div>
      </div>

      {/* Solar Water Heater */}
      <div className="solution-row">
        <div className="solution-content">
          <h2>🚿 Solar Water Heaters</h2>
          <p>
            Energy-efficient solar water heating solutions for homes and
            businesses.
          </p>

          <h4>Applications:</h4>
          <ul>
            <li>Residential homes</li>
            <li>Hotels & hospitals</li>
            <li>Hostels & industries</li>
          </ul>

          <h4>Advantages:</h4>
          <ul>
            <li>Saves electricity and gas costs</li>
            <li>Hot water throughout the year</li>
            <li>Environment-friendly solution</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={waterHeaterImg} alt="Solar Water Heaters" className="solution-image" />
        </div>
      </div>

      {/* Cleaning */}
      <div className="solution-row reverse">
        <div className="solution-content">
          <h2>🧼 Solar Panel Cleaning Services</h2>
          <p>
            Regular cleaning ensures optimal performance of solar panels.
          </p>

          <h4>Our Cleaning Service Includes:</h4>
          <ul>
            <li>Safe and eco-friendly cleaning methods</li>
            <li>Manual & water-fed systems</li>
            <li>Performance efficiency improvement</li>
          </ul>

          <h4>Why Cleaning Matters:</h4>
          <ul>
            <li>Increases power output</li>
            <li>Extends panel lifespan</li>
            <li>Prevents dust & dirt losses</li>
          </ul>
        </div>
        <div className="solution-image-container">
          <img src={cleaningImg} alt="Solar Panel Cleaning Services" className="solution-image" />
        </div>
      </div>
    </section>
      {/* <section className="pricing">
      <h2 className="pricing-title">Flexible Pricing</h2>

      <div className="pricing-grid">
        {plans.map((plan) => (
          <Card
            key={plan.name}
            className={`pricing-card ${plan.featured ? "featured" : ""}`}
            elevation={0}
          >
            <CardContent>
              <h3 className="plan-title">{plan.name}</h3>
              <p className="plan-price">${plan.price}/mo</p>
              <Button variant="contained" className="plan-button">
                Choose Plan
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </section> */}
    </>
  );
}

export default Pricing;
